/* eslint no-restricted-imports:"off" -- All Cookie modifications must happen through this utility to ensure GDPR compliance. */
import Cookie from 'js-cookie';
import { hasConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
export const CookieUtils = {
  getCookie(key) {
    return Cookie.get(key);
  },
  setCookie(key, value, category, options) {
    let valueSet;
    if (category) {
      if (hasConsent(category)) {
        valueSet = Cookie.set(key, value, options);
      }
    } else {
      throw new Error(`No OneTrust category provided for '${key}'. All Cookie entries need to be categorized for EU compliance. Categories are available in 'utils/one-trust/one-trust-compliance'.`);
    }
    return valueSet;
  },
  removeCookie(key) {
    return Cookie.remove(key);
  }
};
export function getCookie(key) {
  return CookieUtils.getCookie(key);
}
export function setCookie(key, value, category, options) {
  return CookieUtils.setCookie(key, value, category, options);
}
export function removeCookie(key) {
  return CookieUtils.removeCookie(key);
}